import { Form, Input } from "antd";
import FormSubmitButton from "components/Common/FormSubmitButton";

const LoginForm = ({ loading, onFinish }) => {
  const [form] = Form.useForm();

  const fieldConfigs = [
    {
      name: "username",
      label: "Username",
      rules: [{ required: true }],
    },
    {
      name: "password",
      label: "Password",
      rules: [{ required: true }],
    },
  ];

  const renderFieldInput = (field) => {
    switch (field) {
      case "password":
        return <Input.Password />;
      default:
        return <Input />;
    }
  };

  return (
    <>
      <Form
        name="login_form"
        form={form}
        onFinish={onFinish}
        onFinishFailed={() => {}}
        requiredMark={false}
      >
        {fieldConfigs.map((fieldConfig, index) => (
          <Form.Item key={index} {...fieldConfig}>
            {renderFieldInput(fieldConfig.name)}
          </Form.Item>
        ))}
        <Form.Item>
          <FormSubmitButton
            form={form}
            label="Log In"
            buttonProps={{
              loading: loading,
              block: true,
            }}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm;
